/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Lead_ReassignedInputs */

const cs_enum_lead_reassigned = /** @type {(inputs: Enum_Lead_ReassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead přeřazen`)
};

const en_enum_lead_reassigned = /** @type {(inputs: Enum_Lead_ReassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead reassigned`)
};

/**
* | output |
* | --- |
* | "Lead reassigned" |
*
* @param {Enum_Lead_ReassignedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_lead_reassigned = /** @type {((inputs?: Enum_Lead_ReassignedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Lead_ReassignedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_lead_reassigned(inputs)
	return cs_enum_lead_reassigned(inputs)
});